/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VerifyMfaCodeModal from "../../MfaModals/verifyMfaCodeModal";
import BackapCodeModal from "../../MfaModals/backapCodeModal";
import { getBackupCode } from "../../../services/mfaServices";

const MfaForm = ({ isRemplacing }) => {
  const [verifyMfaModal, setVerifyMfaModal] = useState(false);
  const [backapModal, setBackapModal] = useState(false);
  const [backupCode, setBackupCode] = useState("");

  const handleBackupCode = (code) => {
    setBackupCode(code);
  };

  const handleBackapModal = () => {
    setBackapModal(!backapModal);
  };

  const handleBackapModalToggle = () => {
    handleBackapModal();
    setBackupCode("");
  };

  const handleVerify = () => {
    getBackupCode().then((r) => {
      setBackupCode(r.code);
    });
  };

  return (
    <div className="card dmx-card-mt flex-grow-1" style={{ height: "fit-content" }}>
      <div className="card-header">
        <h5>AUTENTICACIÓN</h5>
        <div className="card-options">
          <a className="card-options-collapse" href="javascript" data-toggle="card-collapse" aria-label="Toggle Card">
            <i className="fe fe-chevron-up" />
          </a>
          <a className="card-options-remove" href="javascript" data-toggle="card-remove" aria-label="Remove Card">
            <i className="fe fe-x" />
          </a>
        </div>
      </div>
      <div className="m-4">
        <div className="row">
          <div className="md-4 flex-grow-1 mx-4 d-flex align-items-center mb-3">
            <FontAwesomeIcon icon="lock" className="mr-2" color="var(--primary)" />
            <p className="m-0" style={{ color: "var(--primary)" }}>
              AUTENTICACIÓN DE DOS FACTORES HABILITADA
            </p>
          </div>

          <div className="md-4">
            <p className="flex-grow-1 mx-4 font-size-16">
              Protege tu cuenta de PIN con una capa extra de seguridad. Una vez configurada, tendrás que introducir tanto tu contraseña como un código de autentificación
              desde tu teléfono para iniciar sesión.
            </p>
          </div>
        </div>
      </div>

      <div className="card-footer text-right">
        <VerifyMfaCodeModal
          button="Regenerar código de respaldo"
          isOpen={verifyMfaModal}
          isVerified={handleVerify}
          setBackupCode={handleBackupCode}
          toggle={() => {
            setVerifyMfaModal(!verifyMfaModal);
          }}
          handleNextModal={handleBackapModal}
          isRemplacing={isRemplacing}
        />
        <BackapCodeModal isOpen={backapModal} button={false} toggle={handleBackapModalToggle} backupCode={backupCode} setBackupCode={handleBackupCode} />
      </div>
    </div>
  );
};

export default MfaForm;
